import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType, onMounted } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "FilterModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  filters: {
    type: Object as PropType<Map<string, string[]>>,
    required: true,
  },
  initialAppliedFilters: {
    type: Object as PropType<Map<string, string>>,
    requried: true,
  },
},
  emits: ["onClickClose", "onClickApply"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const route = useRoute();

const selectedFilter = ref<Map<string, string>>(
  new Map(props.initialAppliedFilters)
);
const onClickFilter = (key: string, value: string) => {
  selectedFilter.value.set(key, value);
};

const emitOnClickApply = () => {
  emit("onClickApply", selectedFilter.value);
};

const emitOnClickClose = () => {
  route.meta.onBackHandlerList.pop();
  emit("onClickClose");
};

onMounted(() => {
  route.meta.onBackHandlerList.push(emitOnClickClose);
});

const __returned__ = { props, emit, route, selectedFilter, onClickFilter, emitOnClickApply, emitOnClickClose }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})